export function parseSafeDate(value) {
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value : null;
  if (typeof value !== "string" || !value.trim()) return null;
  const raw = value.trim();
  const br = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
  if (!br && !iso) return null;
  const [y, m, d] = br ? [Number(br[3]), Number(br[2]), Number(br[1])] : iso.slice(1).map(Number);
  const day = new Date(Date.UTC(y, m - 1, d, 12));
  if (day.getUTCFullYear() !== y || day.getUTCMonth() !== m - 1 || day.getUTCDate() !== d) return null;
  const date = !br && raw.includes("T") ? new Date(raw) : day;
  return Number.isFinite(date.getTime()) ? date : null;
}
export function formatSafeDate(value) {
  const date = parseSafeDate(value);
  return date ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeZone: "America/Sao_Paulo" }).format(date) : "---";
}
export function formatSafeDateTime(value) {
  const date = parseSafeDate(value);
  return date ? new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short", timeZone: "America/Sao_Paulo" }).format(date) : "---";
}
